"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCompanyDetailsSwaggerMetadata = exports.getCompanyListSwaggerMetadata = void 0;
exports.addTpaSwaggerMetadata = addTpaSwaggerMetadata;
exports.getTpasSwaggerMetadata = getTpasSwaggerMetadata;
exports.getTpaByIdSwaggerMetadata = getTpaByIdSwaggerMetadata;
exports.updateTpaByIdSwaggerMetadata = updateTpaByIdSwaggerMetadata;
exports.deleteTpaByIdSwaggerMetadata = deleteTpaByIdSwaggerMetadata;
exports.getTpaContactsSwaggerMetadata = getTpaContactsSwaggerMetadata;
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const create_tpa_dto_1 = require("./dto/create-tpa.dto");
const update_tpa_dto_1 = require("./dto/update-tpa.dto");
function addTpaSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Add a new TPA",
        description: "Creates a new TPA with the provided details, including address information.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiBody)({
        description: "Details of the TPA to be created.",
        type: create_tpa_dto_1.CreateTpaDto,
    }), (0, swagger_1.ApiResponse)({
        status: 201,
        description: "TPA created successfully.",
        schema: {
            example: {
                status: 201,
                message: "TPA created successfully",
                data: {
                    id: 153,
                    tpaName: "ABC Insurancetrfss",
                    displayName: "ABC Insurance",
                    companyTypeLid: 19,
                    website: "https://www.example.com",
                    remarks: "This is a remark",
                    statusLid: 80,
                    tpaAddresses: [
                        {
                            id: 1359,
                            address1: "123 Main St",
                            address2: "Address v23",
                            area: "Downtown",
                            pinCode: "12345",
                            email: "email@1811.com",
                            phoneNumber: "1234567890",
                            alternatePhoneNumber: "0987654321",
                            supportNumber: "1234567890",
                            countryId: {
                                id: 1,
                                name: "India",
                                isoCode: null,
                            },
                            stateId: {
                                id: 1,
                                name: "Andhra Pradesh",
                            },
                            cityId: {
                                id: 1,
                                name: "Visakhapatnam",
                            },
                            addressTypeLid: 25,
                            addressType: {
                                id: 25,
                                lookUpValue: "Office",
                            },
                        },
                    ],
                    status: {
                        id: 80,
                        lookUpValue: "Active",
                    },
                    companyType: {
                        id: 19,
                        lookUpValue: "Public",
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Invalid input data.",
    }));
}
function getTpasSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve all TPAs",
        description: "Fetches a paginated list of all TPAs with optional search and sorting.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiQuery)({
        name: "search",
        required: false,
        type: String,
        description: "Search term to filter TPAs by name.",
    }), (0, swagger_1.ApiQuery)({
        name: "sort",
        required: false,
        type: String,
        description: "Field to sort the TPAs by.",
    }), (0, swagger_1.ApiQuery)({
        name: "page",
        required: false,
        type: Number,
        description: "Page number for pagination.",
    }), (0, swagger_1.ApiQuery)({
        name: "limit",
        required: false,
        type: Number,
        description: "Number of records per page(by default limit is 10 records).",
    }), (0, swagger_1.ApiQuery)({
        name: "searchBy",
        required: false,
        type: String,
        description: "Search based on tpa name.",
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "List of TPAs retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: { type: "string", example: "TPAs retrieved successfully" },
                data: {
                    type: "object",
                    properties: {
                        data: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    id: { type: "number", example: 145 },
                                    tpaName: { type: "string", example: "ABC Insurance" },
                                    displayName: { type: "string", example: "ABC Insurance" },
                                    status: {
                                        type: "object",
                                        properties: {
                                            id: { type: "number", example: 80 },
                                            lookUpValue: { type: "string", example: "Active" },
                                        },
                                    },
                                    tpaAddresses: {
                                        type: "array",
                                        items: {
                                            type: "object",
                                            properties: {
                                                id: { type: "number", example: 145 },
                                                address1: { type: "string", example: "123 Main St" },
                                                city: {
                                                    type: "object",
                                                    properties: {
                                                        name: {
                                                            type: "string",
                                                            example: "Visakhapatnam",
                                                        },
                                                        id: { type: "number", example: 1 },
                                                    },
                                                },
                                                state: {
                                                    type: "object",
                                                    properties: {
                                                        name: {
                                                            type: "string",
                                                            example: "Andhra Pradesh",
                                                        },
                                                        stateCode: { type: "string", example: "AP" },
                                                        id: { type: "number", example: 1 },
                                                    },
                                                },
                                                country: {
                                                    type: "object",
                                                    properties: {
                                                        name: { type: "string", example: "India" },
                                                        isoCode: { type: "string", example: null },
                                                        id: { type: "number", example: 1 },
                                                    },
                                                },
                                                phoneNumber: {
                                                    type: "string",
                                                    example: "1234567890",
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
            example: {
                status: 200,
                message: "TPAs retrieved successfully",
                data: {
                    data: [
                        {
                            id: 145,
                            tpaName: "ABC Insurance",
                            displayName: "ABC Insurance",
                            status: {
                                id: 80,
                                lookUpValue: "Active",
                            },
                            tpaAddresses: [
                                {
                                    id: 145,
                                    address1: "123 Main St",
                                    city: {
                                        name: "Visakhapatnam",
                                        id: 1,
                                    },
                                    state: {
                                        name: "Andhra Pradesh",
                                        stateCode: "AP",
                                        id: 1,
                                    },
                                    country: {
                                        name: "India",
                                        isoCode: null,
                                        id: 1,
                                    },
                                    phoneNumber: "1234567890",
                                },
                            ],
                        },
                    ],
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
}
function getTpaByIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve a TPA by ID",
        description: "Fetches the details of a specific TPA by its ID.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "TPA retrieved successfully.",
        schema: {
            example: {
                status: 200,
                message: "TPA retrieved successfully",
                data: {
                    id: 145,
                    tpaName: "ABC Insurance",
                    displayName: "ABC Insurance",
                    companyTypeLid: 19,
                    website: "https://www.example.com",
                    remarks: "This is a remark",
                    statusLid: 80,
                    tpaAddresses: [
                        {
                            id: 1112,
                            address1: "123 Main St",
                            address2: "Address v23",
                            area: "Downtown",
                            pinCode: "12345",
                            email: "email@1811.com",
                            phoneNumber: "1234567890",
                            alternatePhoneNumber: "0987654321",
                            supportNumber: "1234567890",
                            countryId: {
                                id: 1,
                                name: "India",
                                isoCode: null,
                            },
                            stateId: {
                                id: 1,
                                name: "Andhra Pradesh",
                            },
                            cityId: {
                                id: 1,
                                name: "Visakhapatnam",
                            },
                            addressTypeLid: 25,
                            addressType: {
                                id: 25,
                                lookUpValue: "Office",
                            },
                        },
                    ],
                    status: {
                        id: 80,
                        lookUpValue: "Active",
                    },
                    companyType: {
                        id: 19,
                        lookUpValue: "Public",
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "TPA not found.",
    }));
}
function updateTpaByIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Update a TPA by ID",
        description: "Updates the details of a specific TPA by its ID.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiBody)({
        description: "Details of the TPA to be updated.",
        type: update_tpa_dto_1.UpdateTpaDto,
        examples: {
            example1: {
                summary: "Sample TPA Updation request",
                value: {
                    tpaName: "Example TPA",
                    displayName: "Example Display Name",
                    companyTypeLid: 19,
                    website: "https://example.com",
                    remarks: "This is a sample TPA.",
                    address: [
                        {
                            addressTypeLid: 25,
                            address1: "123 Main St",
                            address2: "Suite 100",
                            area: "Downtown",
                            pinCode: "123456",
                            email: "contact@example.com",
                            phoneNumber: "1234567890",
                            alternatePhoneNumber: "0987654321",
                            supportNumber: "1800123456",
                            cityId: 1,
                            stateId: 2,
                            countryId: 3,
                        },
                    ],
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "TPA updated successfully.",
        schema: {
            example: {
                status: 200,
                message: "TPA updated successfully",
                data: {
                    id: 145,
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "TPA not found.",
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Invalid input data.",
    }));
}
function deleteTpaByIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Delete a TPA by ID",
        description: "Deletes a specific TPA by its ID.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "TPA deleted successfully.",
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "TPA not found.",
    }));
}
const getCompanyListSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve a paginated list of companies",
        description: "Fetches a paginated list of companies with optional search and sorting functionality. Requires authentication and 'BD' role.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), // Indicates that the endpoint requires a Bearer token for authentication
    (0, swagger_1.ApiQuery)({
        name: "page",
        required: false,
        type: "number",
        description: "Page number for pagination (default: 1)",
        example: 1,
    }), (0, swagger_1.ApiQuery)({
        name: "limit",
        required: false,
        type: "number",
        description: "Number of records per page (by default limit is 10 records)",
        example: 10,
    }), (0, swagger_1.ApiQuery)({
        name: "search",
        required: false,
        type: "string",
        description: "Search term to filter companies by name",
        example: "TechCorp",
    }), (0, swagger_1.ApiQuery)({
        name: "sortBy",
        required: false,
        type: "string",
        description: "Field to sort by (default: displayName)",
        example: "displayName",
    }), (0, swagger_1.ApiQuery)({
        name: "sort",
        required: false,
        enum: ["ASC", "DESC"],
        description: "Sort order (default: ASC)",
        example: "ASC",
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.tpaCompanyListRetrieved,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: messages_1.successMessage.tpaCompanyListRetrieved,
                },
                data: {
                    type: "object",
                    properties: {
                        data: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    id: { type: "number", example: 1 },
                                    tpaName: { type: "string", example: "TechCorp" },
                                    displayName: {
                                        type: "string",
                                        example: "Tech Corporation",
                                    },
                                },
                            },
                        },
                        count: { type: "number", example: 100 },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: messages_1.errorMessages.tpaCompanyListNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: messages_1.errorMessages.tpaCompanyListNotFound,
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 401,
        description: "Unauthorized - Invalid or missing authentication token",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 401 },
                message: { type: "string", example: "Unauthorized" },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 403,
        description: "Forbidden - User does not have the required role",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 403 },
                message: {
                    type: "string",
                    example: "Access denied. User doesn't have permission.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error" },
            },
        },
    }));
};
exports.getCompanyListSwaggerMetadata = getCompanyListSwaggerMetadata;
const getCompanyDetailsSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({ summary: "Get company details by ID" }), (0, swagger_1.ApiParam)({
        name: "id",
        description: "The ID of the company to retrieve details",
        type: String,
    }), (0, swagger_1.ApiBearerAuth)("access-token"), // Indicates that the endpoint requires a Bearer token for authentication
    (0, swagger_1.ApiResponse)({
        status: 200,
        description: "TPA details retrieved successfully",
        schema: {
            example: {
                status: 200,
                message: "TPA details retrieved successfully",
                data: [
                    {
                        id: 143,
                        tpaName: "hhh",
                        displayName: "RLGK",
                        tpaAddresses: [
                            {
                                id: 1,
                                address1: "testing Contact Details",
                                city: {
                                    id: 1,
                                    name: "Visakhapatnam",
                                },
                            },
                        ],
                    },
                ],
            },
        },
    }), (0, swagger_1.ApiResponse)({ status: 404, description: "Company not found" }), (0, swagger_1.ApiResponse)({ status: 500, description: "Internal server error" }));
};
exports.getCompanyDetailsSwaggerMetadata = getCompanyDetailsSwaggerMetadata;
function getTpaContactsSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Get contacts of a TPA",
        description: "Fetches all contacts associated with a specific TPA.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "tpaId",
        required: true,
        description: "ID of the TPA",
        example: 456,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "TPA contacts retrieved successfully.",
        schema: {
            example: {
                status: 200,
                message: "TPA contacts retrieved successfully",
                data: [
                    {
                        id: 583,
                        firstName: "Navanitha",
                        lastName: "Makulla",
                        displayName: "Navanitha Makulla",
                    },
                    {
                        id: 578,
                        firstName: "test tap label",
                        lastName: "label",
                        displayName: "test tap label label12",
                    },
                ],
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "No contacts found for TPA.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Failed to fetch TPA contacts.",
    }));
}
